import { Model } from '@vuex-orm/core'
import shortid from 'shortid'
import _ from 'lodash'

import Device from './Device'

export default class DevicePhone extends Model {
    static entity = 'devicePhones'
    static fields() {
        return {
            deviceId: this.belongsTo(Device, 'deviceId'),
            area: this.attr(null),
            ddd: this.attr(null),
            number: this.attr(null),
        }
    }
}